import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'controller/types';
import { initialState } from '.';

const selectSlice = (state: RootState) => (state as any).digitalMarketing || initialState;

export const selectDigitalMarketing = createSelector([selectSlice], state => state);
